import React from 'react';
import { NavLink } from 'react-router-dom';

import Icone from 'Component/Icone';
import LayoutDefault from 'Component/Layout';
import { useAppSelector } from 'Store';

const Menu = (): React.ReactElement => {
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  return (
    <LayoutDefault>
      <div className="d-flex flex-column flex-shrink-0 text-body">
        <ul className="nav nav-pills flex-column mb-auto mt-4">
          <li className="nav-item">
            <NavLink
              to="/inicio"
              className={({ isActive }) =>
                `nav-link ${isActive && 'text-white active'}`
              }
            >
              <Icone nome="house-fill" className="me-2" />
              Início
            </NavLink>
          </li>
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/empresas"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="briefcase-fill" className="me-2" />
                Empresas
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/departamentos"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="person-rolodex" className="me-2" />
                Departamentos
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/funcoes"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="person-lines-fill" className="me-2" />
                Funções
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/usuarios"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="person-badge-fill" className="me-2" />
                Funcionários
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/relogios-de-ponto"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="alarm-fill" className="me-2" />
                Relógio de ponto
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/fechamentos-de-folha"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="currency-dollar" className="me-2" />
                Fechamento de folha
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/calculadora"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="calculator-fill" className="me-2" />
                Calculadora de Turnover
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/categorias-de-curriculo"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="file-earmark-check-fill" className="me-2" />
                Categorias de Currículo
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/curriculos"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="file-earmark-text-fill" className="me-2" />
                Currículos
              </NavLink>
            </li>
          )}
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/comunicados"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="megaphone-fill" className="me-2" />
                Comunicados
              </NavLink>
            </li>
          )}
          <li className="nav-item">
            <NavLink
              to="/indisponibilidades"
              className={({ isActive }) =>
                `nav-link ${isActive && 'text-white active'}`
              }
            >
              <Icone nome="balloon-fill" className="me-2" />
              Férias e folgas
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/treinamentos"
              className={({ isActive }) =>
                `nav-link ${isActive && 'text-white active'}`
              }
            >
              <Icone nome="person-workspace" className="me-2" />
              Treinamentos
            </NavLink>
          </li>
          <li className="divider">
            <hr />
          </li>
          <li className="nav-item">
            <NavLink
              to="/holerites/historico"
              className={({ isActive }) =>
                `nav-link ${isActive && 'text-white active'}`
              }
            >
              <Icone nome="cash-coin" className="me-2" />
              Histórico de holerites
            </NavLink>
          </li>
          {usuario && ['super', 'admin'].includes(usuario.permissao) && (
            <li className="nav-item">
              <NavLink
                to="/fechamentos-de-folha/historico"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="currency-dollar" className="me-2" />
                Histórico de fecha. folha
              </NavLink>
            </li>
          )}
          <li className="nav-item">
            <NavLink
              to="/relogios-de-ponto/historico"
              className={({ isActive }) =>
                `nav-link ${isActive && 'text-white active'}`
              }
            >
              <Icone nome="alarm-fill" className="me-2" />
              Histórico de rel. ponto
            </NavLink>
          </li>
        </ul>
      </div>
    </LayoutDefault>
  );
};

export default Menu;
